"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : FORM : FIELD : SELECT : STYLES --------------- ++++++++++ */


var _default = {
  select: {
    backgroundColor: 'transparent',
    border: '0',
    color: 'inherit',
    fontSize: (0, _index.pxToEm)(16),
    width: '100%',
    height: 'inherit',
    //pxToEm(50),
    margin: '0',
    padding: '0',
    outline: 'none',
    '&::placeholder': {
      color: _index.theme.color.supporting.dark.swatch,
      opacity: '.4'
    }
  }
};
exports.default = _default;